module.exports = __webpack_public_path__ + "static/media/aboutimg7.f8d1a4d6.webp";